var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiUnitConsumption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-2, .cls-3 {\n        stroke: #323232;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-3 {\n        stroke-width: 1.23px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.1,18.72H7.9c-1.44,0-2.62-1.18-2.62-2.62V7.9c0-1.44,1.18-2.62,2.62-2.62h8.21c1.44,0,2.62,1.18,2.62,2.62v8.21c0,1.44-1.18,2.62-2.62,2.62Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.38,
    y1: 4.5,
    x2: 13.38,
    y2: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 16.15,
    y1: 4.67,
    x2: 16.15,
    y2: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.85,
    y1: 4.67,
    x2: 7.85,
    y2: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.62,
    y1: 4.5,
    x2: 10.62,
    y2: 3.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.38,
    y1: 20.5,
    x2: 13.38,
    y2: 19.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 16.15,
    y1: 20.5,
    x2: 16.15,
    y2: 19.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 7.85,
    y1: 20.5,
    x2: 7.85,
    y2: 19.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.62,
    y1: 20.5,
    x2: 10.62,
    y2: 19.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 19.5,
    y1: 13.38,
    x2: 20.5,
    y2: 13.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 19.33,
    y1: 16.15,
    x2: 20.5,
    y2: 16.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 19.33,
    y1: 7.85,
    x2: 20.5,
    y2: 7.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 19.5,
    y1: 10.62,
    x2: 20.5,
    y2: 10.62
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3.5,
    y1: 13.38,
    x2: 4.5,
    y2: 13.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3.5,
    y1: 16.15,
    x2: 4.67,
    y2: 16.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3.5,
    y1: 7.85,
    x2: 4.67,
    y2: 7.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3.5,
    y1: 10.62,
    x2: 4.5,
    y2: 10.62
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 14.38,
    y1: 8.03,
    x2: 14.38,
    y2: 11.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 12.74,
    y1: 9.67,
    x2: 16.01,
    y2: 9.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.71,16.58c0-1.58-1.28-2.87-2.87-2.87,1.58,0,2.87-1.28,2.87-2.87,0,1.58,1.28,2.87,2.87,2.87-1.52,0-2.87,1.28-2.87,2.87Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiUnitConsumption);
export default __webpack_public_path__ + "static/media/AIUnitConsumption.6f40371d4822c62e21dafbb812ca5e77.svg";
export { ForwardRef as ReactComponent };